import { render } from "./EmailProfileModal.vue?vue&type=template&id=1e967754&scoped=true&ts=true"
import script from "./EmailProfileModal.vue?vue&type=script&lang=ts"
export * from "./EmailProfileModal.vue?vue&type=script&lang=ts"

import "./EmailProfileModal.vue?vue&type=style&index=0&id=1e967754&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e967754"]])

export default __exports__